import React from "react";
import { ReactComponent as DiningTableSvg } from "../svg/dining_table.svg";

export default function DiningTableIcon({ size = 64, color = "#32363F", ...props }) {
  return <DiningTableSvg width={size} height={size} style={{ color }} {...props} />;
}
